import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Input,
  Dropdown
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardSpecimenSubmissionLogReportUX = (props: any) => {
    return(
      <div
        id="CardReportListUX-div-0"
        style={{ padding: "15px 10px", height: "100%", zoom: "90%" }}>
        <div
          id="CardReportListUX-div-1">

          <Form
            id="CardReportListUX-Form-2">
            <FormGroup
              id="CardReportListUX-FormGroup-3"
              style={{ display: "flex", alignItems: "center" }}>
              <FormField
                id="CardReportListUX-FormField-5">
                <label
                  id="CardReportListUX-label-17"
                  style={{ minWidth: "max-content" }}>
                  Member ID
                </label>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-6"
                width="3">
                <Input
                  id="CardReportListUX-Input-22"
                  name="hn"
                  onChange={props.onChangeData}
                  value={props.reportListFilter?.hn}>
                </Input>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-7"
                style={{ marginLeft: "30px" }}>
                <label
                  id="CardReportListUX-label-18"
                  style={{ minWidth: "max-content" }}>
                  ชื่อ - นามสกุล
                </label>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-8"
                width="3">
                <Input
                  id="CardReportListUX-Input-24"
                  name="first_name"
                  onChange={props.onChangeData}
                  value={props.reportListFilter?.first_name}>
                </Input>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-9"
                width="3">
                <Input
                  id="CardReportListUX-Input-23"
                  name="last_name"
                  onChange={props.onChangeData}
                  value={props.reportListFilter?.last_name}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardReportListUX-FormGroup-4"
              style={{ display: "flex", alignItems: "center" }}>
              <FormField
                id="CardReportListUX-FormField-10">
                <label
                  id="CardReportListUX-label-19"
                  style={{ minWidth: "max-content" }}>
                  วันที่ส่งสิ่งส่งตรวจ
                </label>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-11"
                width="2">
                <DateTextBox
                  id="CardReportListUX-DateTextBox-25"
                  onChange={props.onChangeStartDate}
                  value={props.reportListFilter?.start_date}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-12"
                style={{ minWidth: "max-content" }}>
                <label
                  id="CardReportListUX-label-20">
                  ถึง
                </label>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-13"
                width="2">
                <DateTextBox
                  id="CardReportListUX-DateTextBox-26"
                  onChange={props.onChangeEndDate}
                  value={props.reportListFilter?.end_date}>
                </DateTextBox>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-14"
                style={{ marginLeft: "30px" }}>
                <label
                  id="CardReportListUX-label-21">
                  Out Lab
                </label>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-15"
                width="2">
                <Dropdown
                  id="CardReportListUX-Dropdown-27"
                  name="vendor"
                  onChange={props.onChangeData}
                  options={props.outlabOptions}
                  selection={true}
                  value={props.reportListFilter?.vendor}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-34"
                style={{ flex: 1 }}>
              </FormField>
              <FormField
                id="CardReportListUX-FormField-16">
                <div
                  id="CardReportListUX-div-28"
                  style={{ display: "flex" }}>

                  <div
                    id="CardReportListUX-div-29"
                    style={{ marginLeft: "10px" }}>
                    {props.buttonSearch}
                  </div>
                  <div
                    id="CardReportListUX-div-30"
                    style={{ marginLeft: "10px" }}>
                    {props.buttonPrint}
                  </div>
                  <div
                    id="CardReportListUX-div-31"
                    style={{ marginLeft: "10px" }}>
                    {props.buttonDownloadXlsx}
                  </div>
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardReportListUX-div-32">

          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.reportListData}
            defaultPageSize={props.defaultPageSize}
            headers={ `วันที่เวลา\nเก็บสิ่งส่งตรวจ,MemberID\n(หมายเลขรับบริการ),ชื่อผู้รับบริการ,ชนิดส่งสิ่งตรวจ,รายการตรวจ,Out Lab,วันที่เวลา\nส่งสิ่งส่งตรวจ,เจ้าหน้าที่บันทึก\nส่งสิ่งส่งตรวจ`}
            id="CardReportListUX-Table-33"
            keys="collectSpecimenTime,memberID,patientName,specimenName,testNames,outLab,specimenTime,specimenUserName"
            onPageChange={props.handlePageChange}
            onPageSizeChange={props.handlePageSizeChange}
            page={props.currentPage}
            pageSize={props.limit}
            pages={props.totalPage}
            showPagination={!props.pagination}
            style={props.tableStyle || { height: "calc(90vh - 8rem)"}}>
          </Table>
          <div
            id="CardReportListUX-div-35"
            style={{display: props.pagination ? "flex" : "none", justifyContent: "flex-end", marginTop: "0.75rem"}}>
            {props.pagination}
          </div>
        </div>
      </div>
    )
}


export default CardSpecimenSubmissionLogReportUX

export const screenPropsDefault = {}

/* Date Time : Mon Nov 02 2026 09:38:08 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"15px 10px\", height: \"100%\", zoom: \"90%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Form",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-Form-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormGroup-3"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormGroup-4"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-6"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-7"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"30px\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-8"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-9"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-11"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-12"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-13"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-14"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"30px\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-15"
        },
        "width": {
          "type": "value",
          "value": "2"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-16"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Member ID"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-label-17"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ - นามสกุล"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-label-18"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ส่งสิ่งส่งตรวจ"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{ minWidth: \"max-content\" }"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-label-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "Out Lab"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-label-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Input",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-Input-22"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.reportListFilter?.hn"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Input",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-Input-23"
        },
        "name": {
          "type": "value",
          "value": "last_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.reportListFilter?.last_name"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Input",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-Input-24"
        },
        "name": {
          "type": "value",
          "value": "first_name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.reportListFilter?.first_name"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 25,
      "name": "DateTextBox",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-DateTextBox-25"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "value": {
          "type": "code",
          "value": "props.reportListFilter?.start_date"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 26,
      "name": "DateTextBox",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-DateTextBox-26"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "value": {
          "type": "code",
          "value": "props.reportListFilter?.end_date"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Dropdown",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-Dropdown-27"
        },
        "name": {
          "type": "value",
          "value": "vendor"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "options": {
          "type": "code",
          "value": "props.outlabOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.reportListFilter?.vendor"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\" }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-div-30"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\" }"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonDownloadXlsx"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\" }"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-div-32"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 33,
      "name": "Table",
      "parent": 32,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.reportListData"
        },
        "defaultPageSize": {
          "type": "code",
          "value": "props.defaultPageSize"
        },
        "headers": {
          "type": "code",
          "value": " `วันที่เวลา\\nเก็บสิ่งส่งตรวจ,MemberID\\n(หมายเลขรับบริการ),ชื่อผู้รับบริการ,ชนิดส่งสิ่งตรวจ,รายการตรวจ,Out Lab,วันที่เวลา\\nส่งสิ่งส่งตรวจ,เจ้าหน้าที่บันทึก\\nส่งสิ่งส่งตรวจ`"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-Table-33"
        },
        "keys": {
          "type": "value",
          "value": "collectSpecimenTime,memberID,patientName,specimenName,testNames,outLab,specimenTime,specimenUserName"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.handlePageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.handlePageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.currentPage"
        },
        "pageSize": {
          "type": "code",
          "value": "props.limit"
        },
        "pages": {
          "type": "code",
          "value": "props.totalPage"
        },
        "showPagination": {
          "type": "code",
          "value": "!props.pagination"
        },
        "style": {
          "type": "code",
          "value": "props.tableStyle || { height: \"calc(90vh - 8rem)\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardReportListUX-FormField-34"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardReportListUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{display: props.pagination ? \"flex\" : \"none\", justifyContent: \"flex-end\", marginTop: \"0.75rem\"}"
        }
      },
      "seq": 35,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardSpecimenSubmissionLogReportUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
